"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = void 0;
// command.base.ts
const BaseMessage_1 = require("./BaseMessage");
class Command extends BaseMessage_1.BaseMessage {
    getLogType() {
        return 'command';
    }
}
exports.Command = Command;
